export class ChangeRegisterConstants {
  public static readonly ChangeControlSearch_Place_Holder_Text: string = 'Search by Number, Title, Description, Current State, Future State or Rationale';
  public static readonly ChangeControl_Feature: string = 'change control';

  //Filter labels

  public static readonly ChangeControl_Search_Text: string = "searchText";
  public static readonly ChangeControl_Search_Phases_Text: string = "phases";
  public static readonly ChangeControl_Search_Category_Text: string = "category";
  public static readonly ChangeControl_Search_ResponsibleSubBU_Text: string = "responsibleSubBU";

  // Toaster Messages and Severity
  public static readonly Severity_Success: string = 'success';
  public static readonly Severity_Info: string = 'info';
  public static readonly Severity_Err: string = 'error';
  public static readonly Severity_Warning: string = 'warn';
  public static readonly ChangeControlSearchEmpty_Filters: string =
    'At least one search criterion must be defined';

  public static readonly SourceForScopes_From_Search: string ='search'; 

  //Phase constants
  public static readonly COMPLETED_PHASE:string = '5'
   public static readonly VOIDED_PHASE:string = '6'

}